import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { WebsiteSchema, OrganizationSchema } from './components/Schema'
import Header from './components/Header'
import Home from './components/Home'
import DataConsultancyPage from './components/DataConsultancyPage'
import ResidentPage from './components/ResidentPage'
import EvidencePage from './components/EvidencePage'
import NewsPage from './components/NewsPage'
import LeadGenerationCampaignPage from './components/LeadGenerationCampaignPage'
import WhatIsLeadGenerationAndCostsPage from './components/WhatIsLeadGenerationAndCostsPage'
import MostCommonDataIssuesPage from './components/MostCommonDataIssuesPage'
import DataManagementSalesTeamPage from './components/DataManagementSalesTeamPage'
import CustomerDataAcquisitionPage from './components/CustomerDataAcquisitionPage'
import CustomerAcquisitionPage from './components/CustomerAcquisitionPage'
import CustomerInsightPropensityPage from './components/CustomerInsightPropensityPage'
import ResidentEmailPage from './components/ResidentEmailPage'
import ResidentLandlinePage from './components/ResidentLandlinePage'
import ResidentPostalPage from './components/ResidentPostalPage'
import ResidentMobilePage from './components/ResidentMobilePage'
import Time2CallPage from './components/Time2CallPage'
import DataQualityPage from './components/DataQualityPage'
import DataQualityEnhancementPage from './components/DataQualityEnhancementPage'
import DeceasedSuppressionPage from './components/DeceasedSuppressionPage'
import GoneawaySuppressionPage from './components/GoneawaySuppressionPage'
import GoodDataManagementPage from './components/GoodDataManagementPage'
import DirectMailMarketingTipsPage from './components/DirectMailMarketingTipsPage'
import WordleHypePage from './components/WordleHypePage'
import FiveHelpfulTipsPage from './components/FiveHelpfulTipsPage'
import TelephoneSurveyLeadsPage from './components/TelephoneSurveyLeadsPage'
import DataForMarketingPage from './components/DataForMarketingPage'
import DataCleansingPage from './components/DataCleansingPage'
import LeadGenerationMarketingPage from './components/LeadGenerationMarketingPage'
import ConsumerArea from './components/ConsumerArea'
import ContactUs from './components/ContactUs'
import Careers from './components/Careers'
import Unsubscribe from './components/Unsubscribe'
import Footer from './components/Footer'

function App() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.lloydjames.com'

  return (
    <Router>
      <div>
        <Helmet>
          <html lang="en" />
        </Helmet>

        {/* Global structured data */}
        <WebsiteSchema
          name="Lloyd James Data Consultancy"
          url={siteUrl}
          description="Professional data consultancy services for businesses. Expert data management, analysis, and strategic insights."
        />

        <OrganizationSchema
          name="Lloyd James Data Consultancy"
          url={siteUrl}
          logo={`${siteUrl}/logos/lloyd-james-data-consultancy-logo.webp`}
          socialLinks={[]}
        />

        <Header />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/data-consultancy" element={<DataConsultancyPage />} />
            <Route path="/product" element={<ResidentPage />} />
            <Route path="/evidence" element={<EvidencePage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/how-to-create-a-successful-lead-generation-campaign" element={<LeadGenerationCampaignPage />} />
            <Route path="/what-is-lead-generation-and-costs/" element={<WhatIsLeadGenerationAndCostsPage />} />
            <Route path="/most-common-data-issues/" element={<MostCommonDataIssuesPage />} />
            <Route path="/data-management-sales-team" element={<DataManagementSalesTeamPage />} />
            <Route path="/customer-data-online/" element={<CustomerDataAcquisitionPage />} />
            <Route path="/customer-acquisition/" element={<CustomerAcquisitionPage />} />
            <Route path="/customer-insight-and-propensity/" element={<CustomerInsightPropensityPage />} />
            <Route path="/resident-email/" element={<ResidentEmailPage />} />
            <Route path="/resident-landline/" element={<ResidentLandlinePage />} />
            <Route path="/resident-postal/" element={<ResidentPostalPage />} />
            <Route path="/resident-mobile/" element={<ResidentMobilePage />} />
            <Route path="/time2call/" element={<Time2CallPage />} />
            <Route path="/data-quality/" element={<DataQualityPage />} />
            <Route path="/data-quality-enhancement/" element={<DataQualityEnhancementPage />} />
            <Route path="/deceased-suppression/" element={<DeceasedSuppressionPage />} />
            <Route path="/goneaway-suppression/" element={<GoneawaySuppressionPage />} />
            <Route path="/good-data-management/" element={<GoodDataManagementPage />} />
            <Route path="/direct-mail-marketing-tips/" element={<DirectMailMarketingTipsPage />} />
            <Route path="/wordle-how-are-brands-joining-the-hype/" element={<WordleHypePage />} />
            <Route path="/5-helpful-tips-on-buying-new-customers/" element={<FiveHelpfulTipsPage />} />
            <Route path="/telephone-survey-leads/" element={<TelephoneSurveyLeadsPage />} />
            <Route path="/data-for-marketing/" element={<DataForMarketingPage />} />
            <Route path="/data-cleansing/" element={<DataCleansingPage />} />
            <Route path="/lead-generation-marketing/" element={<LeadGenerationMarketingPage />} />
            <Route path="/consumer-area" element={<ConsumerArea />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
          </Routes>
          <Footer />
        </div>
      </Router>
  )
}

export default App